$(function(){
  $('.u_qty_number').change(function(){
    let input_val =parseInt($(this).val());
    console.log('input val',input_val)
    let pro_qty =parseInt($(this).parents('.u_cart_item_bqty_block').find('.u_pro_qty').val());
  let var_policy =$(this).parents('.u_cart_item_bqty_block').find('.u_atc_var_plicy').val();
    console.log('product qty',pro_qty);
    if(var_policy == 'deny' && input_val >= pro_qty )
    {
      console.log('zero--');
            alertify.error('Zero quantity has left');
    }
    else{
      let var_id =$(this).parents('.u_cart_item_bqty_block').find('.u_item_variant_id').val();
    jQuery.post('/cart/change.js', {
            quantity: input_val, 
          id: var_id
})
 setTimeout(function(){
location.reload()
            },1000);

    }
  })
   $(document).on("click",".u_cart_item_remove_block",function() {
        let data_idd = $(this).attr('data-variantid').trim();
        jQuery.post('/cart/change.js', { 
          quantity: 0, 
          id: data_idd
        });
  setTimeout(function(){
   location.reload()
            },1000);
      });
   $('.u_minus').click(function(){
    let input =$(this).parent().find('.u_qty_number');
    let count =parseInt(input.val()) -1;
    let counter = count <1 ?1:count;
    input.val(counter);
    input.attr('value',counter);
      let var_id =$(this).parents('.u_cart_item_qty').find('.u_item_variant_id').val();
  jQuery.post('/cart/change.js', {
            quantity: counter, 
          id: var_id
});     
            setTimeout(function(){
location.reload()
            },1000);
  })
  $('.u_plus').click(function(){
    let input =$(this).parent().find('.u_qty_number');
    let input_val =parseInt(input.val());
    let pro_qty =parseInt($(this).parents('.u_cart_item_qty').find('.u_pro_qty').val());
  let var_policy =$(this).parents('.u_cart_item_qty').find('.u_atc_var_plicy').val();
    console.log('product qty',pro_qty);
    if(var_policy == 'deny' && input_val >= pro_qty )
    {
      console.log('zero--');
            alertify.error('Zero quantity has left');
    }
    else{
                let count =parseInt(input.val()) +1;
    input.val(count);
     input.attr('value',count);
      let var_id =$(this).parents('.u_cart_item_qty').find('.u_item_variant_id').val();
    jQuery.post('/cart/change.js', {
            quantity: count, 
          id: var_id
})
 setTimeout(function(){
location.reload()
            },1000);

    }
  })
})